import { get, put, post, patch } from '../utils/APIClient';
import { createFormDataPayloadWithFile } from '../utils/data-utils';

export const getStudentAssignment = async ({ studentAssignmentId, token, options }) => {
  const result = await get({ url: `student-assignments/${studentAssignmentId}`, token, options });
  return result;
};

export const updateResponseForStudentAssignment = async ({
  assignmentId,
  data,
  token,
  options
}) => {
  return put({ url: `student-assignments/${assignmentId}/response`, data, token, options });
};

export const uploadFileForStudentAssignment = async ({
  assignmentId,
  data,
  uploadedFile: file,
  token,
  options
}) => {
  // Backend updateFileResponseSchema only allows these body fields (+ multipart file).
  // Sending extra keys (answer, answers, readingComprehensionId, uploadedFile, …) returns 400.
  const responsePayload = {
    questionId: data.questionId,
    status: data.status,
    isBookmarked: Boolean(data.isBookmarked)
  };

  if (data._id) {
    responsePayload._id = data._id;
  }

  const payload = createFormDataPayloadWithFile({ data: responsePayload, file });

  return put({
    url: `student-assignments/${assignmentId}/response-file`,
    data: payload,
    token,
    options
  });
};

export const createStudentAssignment = async ({ assignmentId, token, options }) => {
  const result = await post({ url: `student-assignments`, data: { assignmentId }, token, options });
  return result;
};

export const startStudentAssignment = async ({ studentAssignmentId, token, options }) => {
  const result = await put({
    url: `student-assignments/${studentAssignmentId}/start`,
    token,
    options
  });
  return result;
};

export const updateTimeRemaining = async ({ studentAssignmentId, token, data, options }) => {
  const result = await put({
    url: `student-assignments/${studentAssignmentId}/time`,
    token,
    data,
    options
  });
  return result;
};

export const endStudentAssignment = async ({ studentAssignmentId, token, options, endReason }) => {
  const result = await patch({
    url: `student-assignments/${studentAssignmentId}/end`,
    token,
    data: { endReason },
    options
  });
  return result;
};

export const getPracticeQuestionTopics = async ({ token, badges, options }) => {
  const query = badges ? `?badges=${badges}` : '';
  const result = await get({ url: `study-material${query}`, token, options });
  return result;
};

export const generateMediaUploadUrl = async ({ studentAssignmentId, questionId, mediaType, fileExtension, token, options }) => {
  const result = await post({
    url: `student-assignments/${studentAssignmentId}/media-upload-url`,
    data: { questionId, mediaType, fileExtension },
    token,
    options
  });
  return result.data;
};

export const uploadMediaToUrl = async ({ uploadUrl, file, contentType }) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to upload media file');
  }
  
  return true;
};
